import { FintechMmCacheInvalidationGateway } from './fintechMmCacheInvalidationGateway';
import { serviceBrokerFintechMmCacheInvalidationGateway } from './serviceBrokerFintechMmCacheInvalidationGateway';

let gateway: FintechMmCacheInvalidationGateway = serviceBrokerFintechMmCacheInvalidationGateway;

/**
 * Troca o gateway usado para invalidar os caches do fintech-mm. Ponto unico
 * de desacoplamento entre quem escuta o evento de mudanca de contrato e a
 * forma real de comunicacao com o fintech-mm - usado nos testes deste
 * modulo e caso o transporte precise mudar no futuro (hoje, Service Broker
 * via `backendApi.ts`).
 */
export function setFintechMmCacheInvalidationGateway(customGateway: FintechMmCacheInvalidationGateway): void {
  gateway = customGateway;
}

/**
 * Restaura o gateway padrao (Service Broker). Usar no `afterEach`/`afterAll`
 * de quem chamar `setFintechMmCacheInvalidationGateway` em teste.
 */
export function resetFintechMmCacheInvalidationGateway(): void {
  gateway = serviceBrokerFintechMmCacheInvalidationGateway;
}

/**
 * Invalida os caches in-memory de clienteId/token do fintech-mm apos uma
 * mudanca de contrato Fintech confirmada (contratacao, upgrade ou
 * cancelamento).
 *
 * Best-effort: nunca lanca. A operacao de negocio (contratar/cancelar) ja
 * terminou quando esta funcao e chamada - falhar em invalidar o cache nao
 * pode quebrar a jornada do usuario, entao o erro so e logado.
 */
export async function invalidateFintechMmContractCaches(): Promise<void> {
  try {
    await gateway.invalidateContractCaches();
  } catch (error) {
    console.error('Erro ao invalidar caches de contrato Fintech no fintech-mm.', error);
  }
}
